module.exports = __webpack_public_path__ + "static/media/open-builder-3.edc3432d.png";